import { useCallback } from 'react';
import { error as logError } from '@eika-infrastruktur/log';
import checkUrl from '../../utils/checkUrl';
import useQueryParam from '../queryparams/useQueryParam';
const useRedirectOnValidUrl = () => {
    const returnUrl = useQueryParam('returnUrl');
    return useCallback(async () => {
        if (returnUrl) {
            try {
                const valid = await checkUrl(returnUrl);
                if (valid) {
                    window.location.href = returnUrl;
                }
            }
            catch (e) {
                logError(e);
            }
        }
    }, [returnUrl]);
};
export default useRedirectOnValidUrl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUmVkaXJlY3RPblZhbGlkVXJsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2hvb2tzL3VzZVJlZGlyZWN0T25WYWxpZFVybC91c2VSZWRpcmVjdE9uVmFsaWRVcmwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUVwQyxPQUFPLEVBQUUsS0FBSyxJQUFJLFFBQVEsRUFBRSxNQUFNLHlCQUF5QixDQUFDO0FBRTVELE9BQU8sUUFBUSxNQUFNLHNCQUFzQixDQUFDO0FBQzVDLE9BQU8sYUFBYSxNQUFNLDhCQUE4QixDQUFDO0FBRXpELE1BQU0scUJBQXFCLEdBQUcsR0FBRyxFQUFFO0lBQy9CLE1BQU0sU0FBUyxHQUFHLGFBQWEsQ0FBQyxXQUFXLENBQUMsQ0FBQztJQUM3QyxPQUFPLFdBQVcsQ0FBQyxLQUFLLElBQUksRUFBRTtRQUMxQixJQUFJLFNBQVMsRUFBRSxDQUFDO1lBQ1osSUFBSSxDQUFDO2dCQUNELE1BQU0sS0FBSyxHQUFHLE1BQU0sUUFBUSxDQUFDLFNBQVMsQ0FBQyxDQUFDO2dCQUN4QyxJQUFJLEtBQUssRUFBRSxDQUFDO29CQUNSLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBSSxHQUFHLFNBQVMsQ0FBQztnQkFDckMsQ0FBQztZQUNMLENBQUM7WUFBQyxPQUFPLENBQUMsRUFBRSxDQUFDO2dCQUNULFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUNoQixDQUFDO1FBQ0wsQ0FBQztJQUNMLENBQUMsRUFBRSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUM7QUFDcEIsQ0FBQyxDQUFDO0FBRUYsZUFBZSxxQkFBcUIsQ0FBQyJ9